import Vue from "vue";
import CompanyService from "@/service/CompanyService";
import MenuRightSerivce from "@/service/MenuRightService";
import SweetAlertService from "@/service/SweetAlertService";
import StaffService from "@/service/StaffService";
import StaffEmploymentService from "@/service/StaffEmploymentService";
import StoreGetter from "@/constants/StoreGetter";
import { AssessTemp } from "@/model/AssessTemp";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import Setting from "@/constants/Settings";
import IntAssessHdrService from "@/service/IntAssessHdrService";
import AssessTempValidation from "./S081800-AssessTempValidation.js";
import Paginate from "vuejs-paginate";
var AssessTempObj = new AssessTempValidation();
export default {
    name: "AssessTemp",
    mounted() {
        AssessTempObj.AssessTempValidation();
        this.assignRights();
        this.getAllAssessTemp();
    },
    components: {
        paginate: Paginate,
    },
    data: () => ({
        menuRights: { allRights: {}, rightsForThisMenu: {} },
        menuId: Setting.MenuID.S_Assess,
        dictEnum: dictEnum,
        AssessTemp: new AssessTemp(),
        isEditMode: false,
        AssessTempList: [],
        selectAllAssessTemp: false,
        tempAssessTempModel: new AssessTemp(),
        typeList: [
            {
                id: 'INT'
            },
            {
                id: 'PROB'
            }
        ]
    }),
    computed: {
        t() {
            return t;
        },
        user() {
            return this.$store.getters[StoreGetter.user];
        },
    },
    methods: {
        hasRight(key, menuId) {
            if (Object.keys(this.menuRights.allRights).length === 0) {
                return false;
            } else {
                return MenuRightSerivce.hasRightInMenu(
                    this.menuRights.allRights,
                    menuId ? menuId : this.menuId,
                    key
                );
            }
        },
        assignRights() {
            this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
            this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
                x => x.MenuID == this.menuId
            );
        },
        async getAllAssessTemp() {
            var self = this;
            var obj = {}
            const response = await IntAssessHdrService.getAllAssessTemp(obj);
            if (response.data.IsSuccess) {
                self.AssessTempList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        selectAllAssessTempRecord: function () {
            var self = this;
            var IsSelected = self.selectAllAssessTemp;
            self.AssessTempList.forEach(function (val, index) {
                val["isSelected"] = IsSelected;
            });
        },
        deleteMultipleAssessTempPopup: function () {
            var arrayList = [];
            var self = this;
            self.AssessTempList.forEach(function (key, value) {
                if (key.isSelected) {
                    arrayList.push(key);
                }
            });
            if (arrayList.length > 0) {
                $('#deleteAssessTempListModel').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectDeleteRecord));
            }
        },
        async deleteMultipleAssessTemp() {
            var arrayList = [];
            var self = this;
            $('#deleteAssessTempListModel').modal('hide');
            self.AssessTempList.forEach(function (key, value) {
                if (key.isSelected) {
                    arrayList.push(key);
                }
            });
            const obj = {
                assessTempList: arrayList,
            };
            const response = await IntAssessHdrService.deleteAssessTemp(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetAssessTemp();
                await self.getAllAssessTemp();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        OnAssessTempSelect: function (model) {
            this.tempAssessTempModel = model;
        },
        addAssessTemp: function () {
            var self = this;
            $('#AssessTempModel').modal('show');
            self.isEditMode = false;
            self.AssessTemp = new AssessTemp();
            self.$validator.reset();
            self.vErrors.clear();
        },
        async saveAssessTempDetail(obj) {
            var self = this;
            const response = await IntAssessHdrService.addAssessTemp(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetAssessTemp();
                await self.getAllAssessTemp();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        async editAssessTemp(obj) {
            var self = this;
            const response = await IntAssessHdrService.updateAssessTemp(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetAssessTemp();
                await self.getAllAssessTemp();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        async saveAssessTemp() {
            var self = this;
            self.$validator.validateAll().then(result => {
                if (result) {
                    $('#AssessTempModel').modal('hide');
                    const obj = {
                        model: {
                            Type: self.AssessTemp.Type,
                            Grp: self.AssessTemp.Grp,
                            Item: self.AssessTemp.Item,
                            CDesc: self.AssessTemp.CDesc,
                            EDesc: self.AssessTemp.EDesc,
                            OptValue: self.AssessTemp.OptValue,
                        }
                    };
                    if (self.isEditMode) {
                        self.editAssessTemp(obj);
                    }
                    else {
                        self.saveAssessTempDetail(obj);
                    }
                }
            });
        },
        async editAssessTempDetail() {
            var self = this;
            self.isEditMode = true;
            if (self.tempAssessTempModel.EDesc != "") {
                self.AssessTemp = this.tempAssessTempModel;
                self.$validator.reset();
                self.vErrors.clear();
                $('#AssessTempModel').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectEditRecord));
            }
        },
        resetAssessTemp: function () {
            var self = this;
            self.selectAllAssessTemp = false;
            self.isEditMode = false;
            self.AssessTemp = new AssessTemp();
            self.tempAssessTempModel = new AssessTemp();
            self.$validator.reset();
            self.vErrors.clear();
        },
        closeAssessTempPopup: function () {
            var self = this;
            self.selectAllAssessTemp = false;
            self.isEditMode = false;
            self.AssessTemp = new AssessTemp();
            self.tempAssessTempModel = new AssessTemp();
            self.$validator.reset();
            self.vErrors.clear();
            $('#AssessTempModel').modal('hide');
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S081800-AssessTemp/S081800-AssessTemp.js